export default __webpack_public_path__ + "static/media/active_qr_ico.4098c85b.svg";